import { useEffect, useState } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Col, Row } from 'react-bootstrap';
import ProfileEditDialog from './ProfileEditDialog/ProfileEditDialog';

function ProfilesDataTable() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editDialogIsVisible, setEditDialogIsVisible] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');
  const [filters, setFilters] = useState({
    'global': {
      value: null,
      matchMode: FilterMatchMode.CONTAINS
    },
    "description": {
      operator: FilterOperator.AND,
      constraints: [{
        value: null,
        matchMode:
          FilterMatchMode.CONTAINS
      }]
    }
  });

  // #region methods

  const getProfiles = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/profile/findAll`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          setProfiles(data.responseObject);
        } else {
          console.warn('ProfilesDataTable: getProfiles: error: data:', data);
        }
        setLoading(false);
      });
  };

  // #endregion 

  // #region events

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    const _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilter(value);
  }

  const onNewClick = () => {
    setSelectedProfile(null);
    setEditDialogIsVisible(true);
  };

  const onProfileSaved = () => {
    setEditDialogIsVisible(false);
    getProfiles();    
  };

  const onEditClick = (profile) => {
    setSelectedProfile(profile);
    setEditDialogIsVisible(true);
  };

  // #endregion

  // #region templates

  const headerTemplate = (
    <>
      <Row>
        <Col md={8}>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText
              placeholder="Filtrar"
              value={globalFilter}
              onChange={onGlobalFilterChange} />
          </span>          
        </Col>
        <Col md={4}>          
          <Button
            label="Nuevo"
            className="p-button-raised p-button-sm float-end"
            onClick={onNewClick}
          />
        </Col>
      </Row>
    </>
  );

  const dataTableActionsTemplate = (profile) => {
    return (
      <>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-primary p-button-text mr-2"
          onClick={() => onEditClick(profile)} />
      </>
    );
  };

  const dataTableTemplate = (
    <>
      <div className="card">
        <DataTable
          className=""
          showGridlines
          stripedRows
          size="small"
          responsiveLayout="scroll"
          emptyMessage="No se encontraron perfiles"
          value={profiles}
          header={headerTemplate}
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          globalFilterFields={[
            'description'
          ]}>
          <Column
            className='app-w-50-px text-center'
            body={dataTableActionsTemplate}
            exportable={false} />
          <Column
            field="description"
            header="Perfíl"
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por Perfíl"
            sortable />
        </DataTable>
      </div>
    </>
  );

  // #endregion
  
  useEffect(() => {
    getProfiles();
  }, []);

  return (
    <>
      <article>
        {dataTableTemplate}
        <ProfileEditDialog
          visible={editDialogIsVisible}
          onHide={() => setEditDialogIsVisible(false)}
          onProfileSaved={onProfileSaved}
          profile={selectedProfile}
        />
      </article>      
    </>
  );
}

export default ProfilesDataTable;